import { apiUtil } from 'lifesci-ui'

const { getApiPathPrefix, request } = apiUtil

function invivoAuthBasePath() {
  return `${getApiPathPrefix('VUE_APP_BASE_PATH_AUTH')}`
}

function invivoAnimalBasePath() {
  return `${getApiPathPrefix('VUE_APP_BASE_PATH_ANIMAL')}`
}

export function login(data) {
  return request({
    url: invivoAuthBasePath() + '/auth/login',
    method: 'post',
    data
  })
}

export function hasLogin() {
  return request({
    url: invivoAuthBasePath() + '/hasLogin',
    method: 'get',
  })
}



export function getInfo(token) {
  return request({
    url: invivoAuthBasePath() + '/user/info',
    method: 'post',
    data: { token }
  })
}

export function logout() {
  return request({
    url: invivoAuthBasePath() + '/auth/logout',
    method: 'post'
  })
}

export function apiUserMenus(userId) {
  return request({
    url: invivoAnimalBasePath() + `/menu/listByUser`,
    method: 'post',
    params: { userId, app: import.meta.env.VITE_APP_ID }
  })
}

export function apiUserResource(userId) {
  return request({
    url: invivoAnimalBasePath() + `/menu/listResourceByUser`,
    method: 'post',
    params: { userId, app: import.meta.env.VITE_APP_ID }
  })
}
